import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";
import withLayout from "../../../components/desktop/layout/component";
import ErrorHandler from "../../../components/shared/with-error-handler";
import Refer from "../../../components/desktop/refer";
import withReducer from "../../../components/shared/with-reducer";
import injectableReducers from "./injectable";

const Referral = ({ route: { name } }) => {
    const isSharePage = name === "refer-share";
    return (
        <React.Fragment>
            <Helmet>
                <title>
                CARS24 | Refer
                </title>
                <meta name="description" content={"Refer your friends and family to CARS24! Join our referral program today and help others sell their car easily."} />
                <link href={`${appUrl()}/refer/`} rel="canonical" />
            </Helmet>
            <ErrorHandler>
                <Refer isSharePage={isSharePage} />
            </ErrorHandler>
        </React.Fragment>
    );
};

Referral.propTypes = {
    route: PropTypes.object
};
export default withReducer(injectableReducers)(() => ({}), dispatch => ({ dispatch }))(withLayout(Referral));
